"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrowCssHelper = exports.ARROW_SIZE = void 0;
const styled_components_1 = require("styled-components");
exports.ARROW_SIZE = 6;
const arrowBase = (0, styled_components_1.css) `
  /* box model */
  border-style: solid;
  border-width: ${exports.ARROW_SIZE}px;
`;
const arrowBottom = (0, styled_components_1.css) `
  ${arrowBase};

  /* box model */
  border-top-width: 0;
  border-left-color: transparent;
  border-right-color: transparent;

  /* position */
  top: -${exports.ARROW_SIZE}px;
`;
const arrowTop = (0, styled_components_1.css) `
  ${arrowBase};

  /* box model */
  border-bottom-width: 0;
  border-left-color: transparent;
  border-right-color: transparent;

  /* position */
  bottom: -${exports.ARROW_SIZE}px;
`;
const arrowRight = (0, styled_components_1.css) `
  ${arrowBase};

  /* box model */
  border-left-width: 0;
  border-top-color: transparent;
  border-bottom-color: transparent;

  /* position */
  left: -${exports.ARROW_SIZE}px;
`;
const arrowLeft = (0, styled_components_1.css) `
  ${arrowBase};

  /* box model */
  border-right-width: 0;
  border-top-color: transparent;
  border-bottom-color: transparent;

  /* position */
  right: -${exports.ARROW_SIZE}px;
`;
const getArrowCssHelper = (placement) => {
    switch (placement) {
        case 'bottom':
        case 'bottom-end':
        case 'bottom-start':
            return arrowBottom;
        case 'left':
        case 'left-end':
        case 'left-start':
            return arrowLeft;
        case 'right':
        case 'right-end':
        case 'right-start':
            return arrowRight;
        case 'top':
        case 'top-end':
        case 'top-start':
            return arrowTop;
        default:
            return arrowBottom;
    }
};
exports.getArrowCssHelper = getArrowCssHelper;
